export default __webpack_public_path__ + "9114e140b321cf6871ea2122cfdf1d5b.png";